<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :isSearch="isSearch"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @add="addMerchants">
      <div slot="table">
        <marketing-merchants-table :tableData="tableData.list" @del="del"></marketing-merchants-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import MarketingMerchantsTable from "./MarketingMerchantsTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getMarketingMerchantsList,newVue,delByMarketingMerchantsId} from "../../network/marketingMerchants";

  export default {
    name: "marketingMerchantsList",
    components: {MarketingMerchantsTable, MyTable},
    data(){
      return {
        title: "营销商户列表",
        isAdd: true,
        isSearch:false,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/marketingMerchants/list";
      this.common.HeaderLocationTwo.name = "营销商户列表管理"
      this.common.HeaderLocationThree.name = "商户列表"
      getMarketingMerchantsList().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      searchEasy(searchItems,pageNum){
        getMarketingMerchantsList(pageNum).then(res => {
          this.tableData = res.data
        })
      },
      del(id){
        delByMarketingMerchantsId(id).then(res => {
            this.searchEasy(this.searchItems);
          }
        )
      },
      addMerchants(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
